import { Component, OnInit } from '@angular/core';
import { appVersionHistory, versionInterface } from '../../models/app-version';
import { AuthService } from '../../services/auth.service';
import moment from 'moment';

moment.locale("es");

@Component({
  selector: 'app-version',
  templateUrl: './app-version.component.html',
  styleUrls: ['./app-version.component.scss']
})
export class AppVersionComponent implements OnInit {

  public moment = moment;
  public versionList: versionInterface[] = appVersionHistory;
  public lastVersion: versionInterface = appVersionHistory[0];
  public lastVersionDate: string = new Date(this.lastVersion.date).toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' });
  public historyOpened: boolean = false;

  constructor(
    public _auth: AuthService,
  ) { }

  ngOnInit() { }
}
